import React from "react";
import { Nav, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";

const UTMNav = (props) => {
  return (
    <Nav
      className="navbar navbar-expand navbar-dark "
      style={{
        backgroundColor:
          "linear-gradient(90deg,rgba(104, 24, 158, 1) 0%, rgba(150, 48, 171, 1) 50%, rgba(201, 0, 201, 1) 100%)",
        backgroundImage:
          "linear-gradient(90deg,rgba(104, 24, 158, 1) 0%, rgba(150, 48, 171, 1) 50%, rgb(159, 9, 159) 100%)",

        padding: "0.7rem 2rem",
        position: "relative",
      }}
    >
      <img
        src={props.logo_dronewhite}
        alt="profile-img"
        style={{
          margin: "10px",
          height: "42.5px",
          width: "50px",
          top: "24px",
          left: "34px",
        }}
      />
      {/* <Link to={"/home"} className=" logo-text">
        <span>AMETHYST</span>
      </Link> */}
      &nbsp;&nbsp;
      <div className="navbar-nav">
        {/*<li className="nav-item">
  <Link
  to={"/home"}
  className="nav-link"
  style={{ color: "white", fontSize: "24px" }}
  >
  Home
  </Link>
  </li>*/}
        <NavDropdown
          show={props.show}
          onMouseEnter={props.showDropdown}
          onMouseLeave={props.hideDropdown}
          title={
            <div
              className="navbar-nav ml-auto nav-section"
              style={{
                color: "#ffffff",
                //position: "absolute",
              }}
            >
              <li className="nav-item activenav ">tool</li>{" "}
            </div>
          }
          className="nav-dropdown dropdown"
          style={{
            color: "#EDEDED",
            fontFamily: "Montserrat",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "24px",
            lineHeight: "32px",

            //left: "1670px",
            top: "0px",
          }}
        >
          <NavDropdown.Item eventKey="4.1" href="/admin/dashboard">
            จัดการหน่วยงาน
          </NavDropdown.Item>
          <NavDropdown.Item eventKey="4.2" href="/admin/notify">
            แจ้งเตือนการขึ้นบิน
          </NavDropdown.Item>
        
        </NavDropdown>
      
        {/* <NavDropdown
          show={props.showPilot}
          onMouseEnter={props.showDropdownPilot}
          onMouseLeave={props.hideDropdownPilot}
          title={
            <div
              className="navbar-nav ml-auto nav-section"
              style={{
                color: "#ffffff",
                //position: "absolute",
              }}
            >
              <li className="nav-item activenav">Pilot</li>{" "}
            </div>
          }
          className="nav-dropdown"
          style={{
            color: "#EDEDED",
            fontFamily: "Montserrat",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "24px",
            lineHeight: "32px",
            //left: "120px",
            top: "0px",
          }}
        >
          <div>
            <NavDropdown.Item eventKey="4.1" href="/user/pilot/regispilot">
              ลงทะเบียนนักบินทั่วไป
            </NavDropdown.Item>
            <NavDropdown.Item
              eventKey="4.2"
              href="/user/pilot/regispilotspacific"
            >
              ลงทะเบียนนักบินขั้นสูง
            </NavDropdown.Item>
            <NavDropdown.Item
              eventKey="4.3"
              href="/user/pilot/statusoperatingpilot"
            >
              การปฏิบัติการ
            </NavDropdown.Item>
            <NavDropdown.Item
              disabled
              eventKey="4.4"
              href="/user/pilot/statuspilot"
            >
              ประวัติการบิน
            </NavDropdown.Item>
          </div>
        </NavDropdown> */}
    <div>
      En/th
    </div>
       
      </div>
      {props.currentUser ? (
        <div className="navbar-nav ml-auto">
          <NavDropdown
            show={props.showProfile}
            onMouseEnter={props.showDropdownProfile}
            onMouseLeave={props.hideDropdownProfile}
            title={
              <div style={{ display: "flex" }}>
                <div
                  className="navbar-nav ml-auto"
                  style={{
                    color: "#ffffff",
                    right: "30%",
                    //position: "absolute",
                    //top: "-5px",
                    fontSize: "26px",
                    lineHeight: "32px",
                    fontWeight: "400",
                    fontStyle: "normal",
                  }}
                >
                  <li className="nav-item activenav">
                    {props.currentUser.f_name === null
                      ? props.currentUser.email.substring(0, 8)
                      : props.currentUser.f_name.substring(0, 8)}
                    &nbsp;&nbsp;&nbsp;&nbsp;
                  </li>
                </div>
                <div style={{ display: "flex" }}>
                  <div style={{ left: "100%" }}>
                    <div
                      className="navbar-nav ml-auto"
                      style={{
                        position: "absolute",
                        top: "10%",
                        //left: "6%",
                        width: "40px",
                        height: "40px",
                        backgroundColor: "#023E8A",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        fontSize: "26px",
                        color: "white",
                        borderRadius: "50%",
                      }}
                    >
                      {props.currentUser.f_name === null
                        ? props.currentUser.email.charAt(0)
                        : props.currentUser.f_name.charAt(0)}
                    </div>
                  </div>
                </div>
              </div>
            }
            className="nav-dropdown"
            style={{
              color: "#EDEDED",
              fontFamily: "Kanit",
              fontStyle: "normal",
              fontWeight: 400,
              fontSize: "34px",
              //top: "18px",
              //left: "1670px",
              //position: "absolute",
              right: "25%",
              width: "100%",
            }}
          >
            <NavDropdown.Item eventKey="4.1" href="/profile/profileuser">
              โปรไฟล์
            </NavDropdown.Item>
            <NavDropdown.Item eventKey="4.2" onClick={() => props.logOut()}>
              ออกจากระบบ
            </NavDropdown.Item>
          </NavDropdown>
        </div>
      ) : (
        <div className="navbar-nav ml-auto">
          <li className="nav-item">
            {/* <button
    type="button"
    className="text-blue-800"
    onClick={() => keycloak.login()}
  >
    Login
  </button>*/}
            <Link to={"/login"} className="nav-link" style={{ color: "white" }}>
              Login
            </Link>
          </li>

          <li className="nav-item">
            <Link
              to={"/register"}
              className="nav-link"
              style={{ color: "white" }}
            >
              Sign Up
            </Link>
          </li>
        </div>
      )}
    </Nav>
  );
};

export default UTMNav;
